import { AutoFormFieldProps } from "@autoform/react";
import React from "react";
import CustomInputField from "@components/FormFields/CustomInputField";

export const StringField: React.FC<AutoFormFieldProps> = ({
  inputProps,
  error,
  id,
}) => {
  const { key, ...props } = inputProps;

  return (
    <CustomInputField
      id={id}
      className={error ? "border-destructive" : ""}
      {...props}
    />
  );
};
